import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneQRCode.styl';

Vue.component('BXmakerAuthuserphoneQRCode',
    {
        props: {
            url: {
                type: [String, Boolean],
                default: false,
            },
        },
        data: function () {
            return {};
        },
        template: `
            <div class="bxmaker-authuserphone-qrcode"  v-if="url"  >                 
                 <div class="bxmaker-authuserphone-qrcode__img ">                    
                    <img :src="url"  />                             
                 </div>                  
            </div>
        `,
    });